<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/T8pqnS/tc-custom/9780718022396.jpg?1721404630220" alt="This image is the cover for the book Make it Happen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Make it Happen
      </h1>
      <p class="bookDescription body article font2">
        <b>You were created for a purpose, and it's time to make it happen.</b><b><br/></b><i>Make It Happen </i>is the story of how I surrendered my fear, took the leap, and got a life. In my case, a perfectly imperfect, fulfilling life as a mama, a working woman, and a grateful wife. This is the story of how I chose to make "it"—a greater purpose than mine—happen, and how you can too.<br/><i>Make It Happen</i> is forwomen who find themselves worried, anxious, and completely overwhelmed by the constant chase for perfectionthose seeking the courage to jump into a new ventureworking women who are struggling to "do it all"weary wives and moms looking for relief from burning the candle at both endsanyone who dreams of a life lived not by accident, but on purposeYour time has come to take a leap of faith. Join me as we surrender our fears, end the chase for perfection, and say yes to cultivating the meaningful lives God desires for us.<br/><i>You know all those things you've always wanted to do?</i><i>You should go do them.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lara Casey
      </h2>
      
      <p class="authorDescription body article"><P>Lara Casey is a mom to three (one through the gift of adoption), a grateful wife, and a believer in the impossible. She created the PowerSheets grace-filled goal setting planner and the Write the Word journals, and she founded <I>Southern Weddings</I> Magazine a decade ago. Lara is also the author of <I>Make It Happen: Surrender Your Fear. Take the Leap. Live On Purpose</I>. She lives in Chapel Hill, NC, and loves getting her hands dirty in the garden.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2196b7de